import RestfulClient from 'restful-json-api-client'

export default class ProjectStringsAlertsApi extends RestfulClient {
  constructor(slug) {
    super(`/api/projects/${slug}`, { resource: 'strings_alerts' })
  }

  bulkUpdate(pathPattern, locale) {
    return this.request('POST', {
      body: { path_pattern: pathPattern, locale },
      path: 'bulk_update'
    })
  }

  keep(id) {
    return this.request('POST', { path: `${id}/keep` })
  }
}
